import { generateUUID } from 'core/common/utils/generateUUID';
import { HttpClientDecorator } from './HttpClientDecorator';
import { HttpRequestConfig } from './entities';
import { HttpClient } from './interfaces';

export class HttpClientWithRequestId extends HttpClientDecorator {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  get<ResponseData = unknown, ResponseMeta = unknown>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.get<ResponseData, ResponseMeta>(url, {
      ...config,
      headers: {
        'x-request-id': generateUUID(),
        ...config.headers,
      },
    });
  }

  post<ResponseData = unknown, ResponseMeta = unknown>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.post<ResponseData, ResponseMeta>(url, {
      ...config,
      headers: {
        'x-request-id': generateUUID(),
        ...config.headers,
      },
    });
  }

  put<ResponseData = unknown, ResponseMeta = unknown>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.put<ResponseData, ResponseMeta>(url, {
      ...config,
      headers: {
        'x-request-id': generateUUID(),
        ...config.headers,
      },
    });
  }

  patch<ResponseData = unknown, ResponseMeta = unknown>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.patch<ResponseData, ResponseMeta>(url, {
      ...config,
      headers: {
        'x-request-id': generateUUID(),
        ...config.headers,
      },
    });
  }

  delete<ResponseData = unknown, ResponseMeta = unknown>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.delete<ResponseData, ResponseMeta>(url, {
      ...config,
      headers: {
        'x-request-id': generateUUID(),
        ...config.headers,
      },
    });
  }
}
